import type { GameMessage, PhysicsEvent } from '../types';
import type { GameState } from './physics';

export function encodeState(s: GameState, events?: PhysicsEvent[]): GameMessage {
  const msg: GameMessage = {
    t: 'state',
    tick: s.tick,
    puck: { x: s.puck.pos.x, y: s.puck.pos.y, vx: s.puck.vel.x, vy: s.puck.vel.y },
    hostPaddle: { x: s.host.pos.x, y: s.host.pos.y },
    guestPaddle: { x: s.guest.pos.x, y: s.guest.pos.y },
    score: { ...s.score },
    phase: s.phase,
  };
  if (events && events.length > 0) {
    msg.events = events.slice();
  }
  if (s.paused) msg.paused = true;
  return msg;
}

export function encodeInput(x: number, y: number, seq: number): GameMessage {
  return { t: 'input', x, y, seq };
}

export function parse(data: string | ArrayBuffer): GameMessage | null {
  try {
    const text = typeof data === 'string' ? data : new TextDecoder().decode(data);
    return JSON.parse(text) as GameMessage;
  } catch {
    return null;
  }
}

export function serialize(msg: GameMessage): string {
  return JSON.stringify(msg);
}
